import { Configuration } from '@azure/msal-browser';
import { environment } from 'src/app/environments/environment';

const b2eConfig = {
  authority:
    'https://login.microsoftonline.com/e7520e4d-d5a0-488d-9e9f-949faae7dce8',
};

export function getMsalConfig(): Configuration {
  return {
    auth: {
      clientId: environment.B2E_clientId,
      authority: b2eConfig.authority,
      knownAuthorities: [],
      redirectUri: environment.redirectURI,
      postLogoutRedirectUri: environment.redirectURI,
    },
  };
}
